import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";

import { API_URL } from "./token.service";

import "rxjs/add/operator/filter";

@Injectable()
export class _TradingAccountService {
  constructor(private http: HttpClient) {}

  getList(id: number) {
    return this.http.get(`${API_URL}/trading-accounts/${id}`).toPromise();
  }
}



// WEBPACK FOOTER //
// /app/wiserisk-core/src/main/ng4app/src/app/services/tradingAccount.service.ts